import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useMediaQuery,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { PublicEventStep } from "../wizardSteps";
import { PublicEventNavigation } from "./PublicEventNavigation";

interface Props {
  currentStep: PublicEventStep;
  navigateToStep: (step: PublicEventStep) => void;
}

export const MobileStepDrawer = ({ currentStep, navigateToStep }: Props) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const { t } = useTranslation();

  const closeAndNavigate = (step: PublicEventStep) => {
    setShowDrawer(false);
    navigateToStep(step);
  };

  if (isLargerThan768) return null;

  return (
    <>
      <Drawer placement="bottom" onClose={() => setShowDrawer(false)} isOpen={showDrawer}>
        <DrawerOverlay />
        <DrawerContent borderTop="1px solid" borderColor="smBorder">
          <DrawerBody py="4">
            <PublicEventNavigation currentStep={currentStep} navigateToStep={closeAndNavigate} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Flex
        position="fixed"
        zIndex={1}
        bottom="0px"
        width="full"
        height="60px"
        borderTop="1px solid"
        borderColor="smBorder"
        alignItems="center"
        bg="smBackground"
      >
        <Button
          variant="solid"
          colorScheme="teal"
          width="full"
          ml="10px"
          mr="10px"
          onClick={() => setShowDrawer(true)}
        >
          {t("Change step")}
        </Button>
      </Flex>
    </>
  );
};
